const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "4.1 3 10.5 10.7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pin",
    d: "M9.41248 3.41248L10.2374 4.23744M14.3622 8.36223L13.5373 7.53727M10.2374 4.23744L6.93761 7.53727L5.07462 7.16467C4.95004 7.13976 4.82125 7.17875 4.73142 7.26858V7.26858C4.58303 7.41697 4.58303 7.65756 4.73142 7.80595L7.35008 10.4246M10.2374 4.23744L13.5373 7.53727M13.5373 7.53727L10.2374 10.8371L10.61 12.7001C10.635 12.8247 10.596 12.9535 10.5061 13.0433V13.0433C10.3577 13.1917 10.1171 13.1917 9.96875 13.0433L7.35008 10.4246M7.35008 10.4246L4.46273 13.312",
    stroke: "red",
    style: {
      stroke: "red",
      strokeOpacity: 1
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.8baa657dff26e75fe0ca3a0090816cae.svg";
export { ForwardRef as ReactComponent };